export default __webpack_public_path__ + "static/media/advertise.a70ea3c7.png";